import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// P1 DEPLOY: Import build info for deployment validation
import BUILD_INFO from "@/buildInfo";

// Log build info on startup
console.info('[AME] Build Info:', BUILD_INFO);
console.info('[AME] Build Marker:', BUILD_INFO.marker);

// P0 FIX: Aggressively unregister any stale service workers on startup
// This prevents iOS Safari caching bugs where POST becomes GET
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => {
      registration.unregister();
      console.info('[SW_CLEANUP] Unregistered stale service worker:', registration.scope);
    });
  }).catch((error) => {
    console.warn('[SW_CLEANUP] Failed to unregister service workers:', error);
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
